export enum Operators {
    Билайн = 1,
    Мегафон = 2,
    МТС = 3,
    Yota = 5,
    Tele2 = 8,
    Ростелеком = 15,
    'D-Билайн' = 17,
    'D-Мегафон' = 19,
    'D-МТС' = 20,
}

export enum OperatorType {
    beeline = 1,
    megafon = 2,
    mts = 3,
    yota = 5,
    t2 = 8,
    rt = 15,
    'd-beeline' = 17,
    'd-megafon' = 19,
    'd-mts' = 20,
}
